/**
 * Beevee: inject backup CSS only (OOS pills styled all-white in component CSS; no DOM removal).
 */
(function () {
  var STYLE_ID = 'beevee-oos-pills-inline-css';
  if (document.getElementById(STYLE_ID)) return;
  var s = document.createElement('style');
  s.id = STYLE_ID;
  s.textContent = [
    '.product-form__input--pill input[type=radio].disabled+label,',
    '.product-form__input--pill input[type=radio]:disabled+label{',
    'color:#fff!important;-webkit-text-fill-color:#fff!important;',
    'background:#fff!important;border-color:#fff!important;',
    'text-decoration:none!important;box-shadow:none!important;}',
  ].join('');
  document.head.appendChild(s);
})();
